import { useCarousel } from "@/components/ui/carousel"
import { cn } from "@/lib/utils"

import { promoTexts as t } from "../localization/texts"

type PromoDotsProps = {
  count: number
  className?: string
}

export function PromoDots({ count, className }: PromoDotsProps) {
  const { selectedIndex, scrollTo } = useCarousel()
  const activeIndex = selectedIndex % count

  return (
    <div
      className={cn("my-2 flex justify-center gap-2", className)}
      role="tablist"
      aria-label={t.ariaLabel}
    >
      {Array.from({ length: count }, (_, index) => (
        <button
          key={index}
          type="button"
          role="tab"
          aria-label={`${t.dotLabel} ${index + 1}`}
          aria-selected={activeIndex === index}
          onClick={() => scrollTo(index)}
          className={cn(
            "h-2.5 w-8.5 shrink-0 rounded-full",
            activeIndex === index
              ? "bg-linear-to-t from-[#9016FF] to-[#490192]"
              : "bg-black-600"
          )}
        />
      ))}
    </div>
  )
}
